export function popupCenter() {
    const left = (screen.width / 2) - (630 / 2),
        top = (screen.height / 2) - (710 / 2);

    return {
        left: Math.abs(left),
        top: Math.abs(top),
    };
}